// DropDown.tsx
import React from 'react';
import { Select, Badge } from '@appkit4/react-components';

interface DropDownOption {
    value: string;
    label: string;
    badgeValue?: string;
    iconName?: string;
    descValue?: string;
}

interface DropDownProps {
    data: DropDownOption[];
    placeholder?: string;
    value?: string | string[]; // single or multi
    onSelect?: (value: string | string[]) => void;
    required?: boolean;
    className?: string;
    dropdownClassName?: string;
    dropdownRenderMode?: 'default' | 'portal';
    getPopupContainer?: () => HTMLElement;
    multiple?: boolean;
    showSelectAll?: boolean;
}

const DropDown = ({
    data,
    placeholder = 'Select option',
    value,
    onSelect,
    required = false,
    className,
    dropdownClassName,
    dropdownRenderMode,
    getPopupContainer,
    multiple = false,
    showSelectAll = false,
}: DropDownProps) => {
    // Normalize what Select gives us to string | string[]
    const handleSelect = (selected: any) => {
        let v: string | string[] | undefined;

        if (Array.isArray(selected)) {
            // multi-select case: array of values or option objects
            if (selected.length === 0) {
                v = [];
            } else if (typeof selected[0] === 'string') {
                v = selected as string[];
            } else {
                v = selected.map((item: any) => item.value as string);
            }
        } else if (typeof selected === 'string') {
            v = selected;
        } else if (
            selected &&
            typeof selected === 'object' &&
            'value' in selected
        ) {
            v = selected.value as string;
        }

        if (v !== undefined && onSelect) {
            onSelect(v);
        }
    };

    return (
        <Select
            className={className}
            dropdownClassName={dropdownClassName}
            dropdownRenderMode={dropdownRenderMode}
            getPopupContainer={getPopupContainer}
            data={data}
            placeholder={placeholder}
            required={required}
            value={value}
            onSelect={handleSelect}
            multiple={multiple}
            showSelectAll={showSelectAll}
            badgeTemplate={(item) =>
                item.badgeValue && (
                    <Badge
                        size="lg"
                        style={{ marginLeft: 8 }}
                        value={item.badgeValue}
                    />
                )
            }
            prefixTemplate={(item) =>
                item.iconName && (
                    <span className={`Appkit4-icon icon-${item.iconName}`} />
                )
            }
            suffixTemplate={(item) => item.descValue}
        />
    );
};

export default DropDown;
export type { DropDownOption, DropDownProps };
